import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";
import { CounterPill } from "./CrmShell";

/** iter201 — « N projets » ouvre AFFICHER LES PROJETS. `selected` : null = tous, sinon liste d'ids. Chaque case filtre immédiatement ; « Appliquer » ferme. */
export default function ProjectPickerPill({ projects, selected, onChange }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  useEffect(() => {
    if (!open) return;
    const close = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);
  const ids = projects.map((p) => p.id);
  const current = selected === null ? ids : selected.filter((id) => ids.includes(id));
  const toggle = (id) => { const next = current.includes(id) ? current.filter((x) => x !== id) : [...current, id]; onChange(next.length === ids.length ? null : next); };
  return (
    <span ref={ref} className="relative inline-flex">
      <CounterPill tone="violet" onClick={() => setOpen((o) => !o)} testId="crm-counter-projects" aria-expanded={open}>{projects.length} projet{projects.length > 1 ? "s" : ""}<ChevronDown size={12} /></CounterPill>
      {open && (
        <div className="absolute" style={{ top: "calc(100% + 6px)", left: 0, zIndex: 60, width: 280, background: "#1e1e24", border: "1px solid #3a3a42", borderRadius: 10, boxShadow: "0 8px 24px rgba(0,0,0,.5)", padding: 8 }} data-testid="crm-project-picker">
          <div style={{ fontSize: 10, letterSpacing: ".08em", color: "#8a8a92", padding: "4px 6px 8px", fontWeight: 700 }}>AFFICHER LES PROJETS</div>
          <div className="flex flex-col" style={{ gap: 2, maxHeight: 260, overflowY: "auto" }}>
            {projects.map((p) => { const on = current.includes(p.id); return (
              <button type="button" key={p.id} onClick={() => toggle(p.id)} className="flex items-center w-full text-left" style={{ gap: 8, padding: "7px 8px", borderRadius: 7, fontSize: 12.5, color: "#e7e7ea", background: on ? "#26262e" : "transparent" }} data-testid={`crm-project-pick-${p.id}`} data-checked={on} role="checkbox" aria-checked={on}>
                <span className="inline-flex items-center justify-center shrink-0" style={{ width: 15, height: 15, borderRadius: 4, border: `1px solid ${on ? "#7F77DD" : "#3a3a42"}`, background: on ? "#7F77DD" : "transparent" }}>{on && <Check size={11} style={{ color: "#fff" }} />}</span>
                <span className="truncate">{p.name}</span>
              </button>); })}
          </div>
          <div className="flex items-center justify-between" style={{ marginTop: 8, paddingTop: 8, borderTop: "1px solid #2a2a32" }}>
            <span className="flex items-center" style={{ gap: 10 }}>
              <button type="button" onClick={() => onChange([])} style={{ fontSize: 11.5, color: "#9a9aa2" }} data-testid="crm-project-pick-none">Tout décocher</button>
              <button type="button" onClick={() => onChange(null)} style={{ fontSize: 11.5, color: "#9a9aa2" }} data-testid="crm-project-pick-all">Tout cocher</button>
            </span>
            <button type="button" onClick={() => setOpen(false)} style={{ fontSize: 12, padding: "5px 12px", borderRadius: 7, background: "#7F77DD", color: "#fff", fontWeight: 600 }} data-testid="crm-project-pick-apply">Appliquer</button>
          </div>
        </div>
      )}
    </span>
  );
}
